import React, { useEffect, useState } from "react";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { useDispatch, useSelector } from "react-redux";
import { rentalAcceptReject } from "../../../../redux/rental/action";
import {
  Commas,
  getDateFormate,
} from "../../../Common/AllDateTimeReleventFormate";
import PostNotFound from "../../../CustomComponents/AllLoader/PostNotFound";
import { saleAcceptReject } from "../../../../redux/sale/action";
import useChatNavigation from "../../../Common/useChatNavigation";
import { bxpAcceptReject, getBxpTogether1 } from "../../../../redux/ots/action";
import OTSViewModel from "./Models/OTSViewModel";
import RentalDetailsLabel from "../../../Common/Label/RentalDetailsLabel";
import ProfilePic from "../../../../assests/imgs/Profileplaceholder.svg";
import { useNavigate } from "react-router-dom";
import ConfirmModal from "../../../Common/ConfirmModal";

export default function PendingRequests({ count }) {
  const dispatch = useDispatch();
  const { letChat } = useChatNavigation();
  const [viewmodel, setviewModel] = useState(false);
  const [data, setData] = useState(false);
  const [type, setType] = useState("");
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate()

  const [confirmDeclineModal, setConfirmDeclineModal] = useState(false);
  const [declineData, setDeclineData] = useState({ id: null, type: null });

  const triggerDecline = (id, reqType) => {
    setDeclineData({ id, type: reqType });
    setConfirmDeclineModal(true);
  };

  const confirmDeclineAction = () => {
    setConfirmDeclineModal(false);
    if (declineData.type === 'bxp') rejectacceptbxp(declineData.id, 2);
    else if (declineData.type === 'sale') rejectacceptsale(declineData.id, 2);
    else if (declineData.type === 'rental') rejectacceptrental(declineData.id, 2);
  };

  const rejectacceptrental = (id, status) => {
    const data = {
      type: "1",
      rental_request_id: id,
      status: status,
    };
    dispatch(rentalAcceptReject(data));
  };

  const rejectacceptsale = (id, status) => {
    const data = {
      type: "1",
      sale_request_id: id,
      status: status,
    };
    dispatch(saleAcceptReject(data));
  };

  const rejectacceptbxp = (id, status) => {
    const data = {
      type: "1",
      bxp_request_id: id,
      status: status,
    };
    dispatch(bxpAcceptReject(data));
  };

  const signcontractforots = (id, status) => {
    const data = {
      type: "1",
      bxp_request_id: id,
      status: status,
    };
    // dispatch(bxpAcceptReject(data));
    navigate(`/${lan}/otscontract/${id}`, { state: { approvefrom: 'user', owner: true, its: 'request' } });
  };

  const togeter1 = useSelector(
    ({ ots: { bxptogetherlist1 } }) => bxptogetherlist1
  );

  useEffect(() => {
    dispatch(getBxpTogether1(1));
  }, []);

  const accept = () => {
    setviewModel(false);
    if (type == 1) {
      rejectacceptbxp(data?.id, 2);
    }
    if (type == 2) {
      rejectacceptsale(data?.id, 2);
    }
    if (type == 3) {
      rejectacceptrental(data?.id, 2);
    } else {
      return null;
    }
    setviewModel(false);
    setData("");
    setType("");
  };

  const reject = () => {
    setviewModel(false);
    if (type == 1) {
      rejectacceptbxp(data?.id, 3);
    }
    if (type == 2) {
      rejectacceptsale(data?.id, 3);
    }
    if (type == 3) {
      rejectacceptrental(data?.id, 3);
    } else {
      return null;
    }
    setviewModel(false);
    setData("");
    setType("");
  };
  useEffect(() => {
    if (viewmodel) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    return () => {
      document.body.classList.remove("modal-open");
    };
  }, [viewmodel]);

  let lastDisplayedDate = null;


  const saleContract = (id) => {
    navigate(`/${lan}/salecontract/${id}`, {
      state: { approvefrom: "seller", type: "sale" },
    });
  };

  const rentalContract = (id) => {
    navigate(`/${lan}/rentalcontract/${id}`, {
      state: { approvefrom: "seller", type: "sale" },
    })
  }


  return (
    <>
      <div className="posted-project umbrellaproject-sec pending-req">
        <>
          <h4>One Time Services (OTS) ({count?.bxp || 0})</h4>
          {Array.isArray(togeter1?.bxp) && togeter1?.bxp?.length > 0 ? (
            <>
              {togeter1?.bxp.map((item, index) => {
                const currentDate = item.created_on.split(" ")[0];
                const shouldDisplayDate = currentDate !== lastDisplayedDate;
                lastDisplayedDate = currentDate;
                return (
                  <div className="pending-row" key={index}>
                    {shouldDisplayDate && (
                      <h6 className="date-name">
                        {getDateFormate(item.created_on)}
                      </h6>
                    )}
                    <div className="pending-img cursor-pending">
                      <div className="row align-items-center">
                        <div
                          className="col-md-5"
                          onClick={() => {
                            setviewModel(true);
                            setData(item);
                            setType(1);
                          }}
                        >
                          <div className="pending-left">
                            <img
                              src={
                                item?.cover
                                  ? item?.cover
                                  : Array.isArray(item?.files) &&
                                  item?.files[0]?.file
                              }
                              alt=""
                            />
                            <div>
                              <h5>{item?.title}</h5>
                              <h3>
                                ${" "}
                                {Commas(
                                  item?.total_price
                                    ? item?.total_price
                                    : item?.price
                                )}
                              </h3>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="pending-center">
                            <img src={item?.profile_image ? item?.profile_image : ProfilePic} alt="" />
                            <div>
                              <p>
                                {item?.is_mine == 0 ? "Seller" : "Ordered by"}
                                <p>
                                  {" "}
                                  <img
                                    src={`${CloudStorage.cloudurl}/Assets/Images/common/star-1.svg`}
                                    alt=""
                                  />{" "}
                                  {item?.rating || 0} ({item?.reviews || 0}{" "}
                                  reviews)
                                </p>
                              </p>
                              <h5>
                                {item?.first_name} {item?.last_name}
                              </h5>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="pending-right">
                            <button
                              onClick={() => letChat(item)}
                              className="buttons border-button"
                            >
                              <img
                                src={`${CloudStorage.cloudurl}/Assets/Images/common/message-color.svg`}
                                alt=""
                              />
                            </button>
                            <button
                              className="buttons border-button"
                              onClick={() => triggerDecline(item?.id, 'bxp')}
                            >
                              Decline
                            </button>
                            <button
                              className="buttons background-button"
                              onClick={() => signcontractforots(item?.id, 3)}
                            >
                              {" "}
                              Accept
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </>
          ) : (
            <PostNotFound title={"No Post Found"} height={200} />
          )}
        </>
        <>
          <h4>Buy & Sell with Market (BSM) requests ({count?.sale || 0})</h4>
          {Array.isArray(togeter1?.sale) && togeter1?.sale?.length > 0 ? (
            <>
              {togeter1?.sale.map((item, index) => {
                const currentDate = item.created_on.split(" ")[0];
                const shouldDisplayDate = currentDate !== lastDisplayedDate;
                lastDisplayedDate = currentDate;
                return (
                  <div className="pending-row">
                    {shouldDisplayDate && (
                      <h6 className="date-name">
                        {getDateFormate(item.created_on)}
                      </h6>
                    )}
                    <div className="pending-img cursor-pending">
                      <div className="row align-items-center">
                        <div
                          className="col-md-5"
                          onClick={() => {
                            setviewModel(true);
                            setData(item);
                            setType(2);
                          }}
                        >
                          <div className="pending-left">
                            <img
                              src={
                                item?.cover
                                  ? item?.cover
                                  : Array.isArray(item?.files) &&
                                  item?.files[0]?.file
                              }
                              alt=""
                            />
                            <div>
                              <h5>{item?.title}</h5>
                              <h3>
                                ${" "}
                                {Commas(
                                  item?.total_price
                                    ? item?.total_price
                                    : item?.price
                                )}
                              </h3>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="pending-center">
                            <img src={item?.profile_image ? item?.profile_image : ProfilePic} alt="" />
                            <div>
                              <p>
                                {item?.is_mine == 0 ? "Seller" : "Ordered by"}
                                <p>
                                  {" "}
                                  <img
                                    src={`${CloudStorage.cloudurl}/Assets/Images/common/star-1.svg`}
                                    alt=""
                                  />{" "}
                                  {item?.rating || 0} ({item?.reviews || 0}{" "}
                                  reviews)
                                </p>
                              </p>
                              <h5>
                                {item?.first_name} {item?.last_name}
                              </h5>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="pending-right">
                            <button
                              onClick={() => letChat(item)}
                              className="buttons border-button"
                            >
                              <img
                                src={`${CloudStorage.cloudurl}/Assets/Images/common/message-color.svg`}
                                alt=""
                              />
                            </button>
                            <button
                              className="buttons border-button"
                              onClick={() => triggerDecline(item?.id, 'sale')}
                            >
                              Decline
                            </button>
                            <button
                              className="buttons background-button"
                              // onClick={() => rejectacceptsale(item?.id, 3)}
                              onClick={() => saleContract(item?.id)}
                            >
                              {" "}
                              Accept
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </>
          ) : (
            <PostNotFound title={"No Post Found"} height={200} />
          )}
        </>
        <>
          <h4>Turn Assets to Income (TAI) requests ({count?.rental || 0})</h4>
          {Array.isArray(togeter1?.rental) && togeter1?.rental?.length > 0 ? (
            <>
              {togeter1?.rental.map((item, index) => {
                const currentDate = item.created_on.split(" ")[0];
                const shouldDisplayDate = currentDate != lastDisplayedDate;
                lastDisplayedDate = currentDate;
                return (
                  <div className="pending-row" key={index}>
                    {shouldDisplayDate && (
                      <h6 className="date-name">
                        {getDateFormate(item.created_on)}
                      </h6>
                    )}
                    <div className="pending-img cursor-pending">
                      <div className="row align-items-center">
                        <div
                          className="col-md-5"
                          onClick={() => {
                            setviewModel(true);
                            setData(item);
                            setType(3);
                          }}
                        >
                          <div className="pending-left">
                            <img src={item?.files[0]?.file} alt="" />
                            <div>
                              <h5>{item?.title}</h5>
                              <h3>
                                ${" "}
                                {Commas(
                                  item?.total_price
                                    ? item?.total_price
                                    : item?.price
                                )}
                              </h3>
                              <RentalDetailsLabel item={item} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="pending-center">
                            <img src={item?.profile_image ? item?.profile_image : ProfilePic} alt="" />
                            <div>
                              <p>
                                {item?.is_mine == 0 ? "Seller" : "Ordered by"}
                                <p>
                                  {" "}
                                  <img
                                    src={`${CloudStorage.cloudurl}/Assets/Images/common/star-1.svg`}
                                    alt=""
                                  />{" "}
                                  {item?.rating || 0} ({item?.reviews || 0}{" "}
                                  reviews)
                                </p>
                              </p>
                              <h5>
                                {item?.first_name} {item?.last_name}
                              </h5>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="pending-right">
                            <button
                              onClick={() => letChat(item)}
                              className="buttons border-button"
                            >
                              <img
                                src={`${CloudStorage.cloudurl}/Assets/Images/common/message-color.svg`}
                                alt=""
                              />
                            </button>
                            <button
                              className="buttons border-button"
                              onClick={() => triggerDecline(item?.id, 'rental')}
                            >
                              Decline
                            </button>
                            <button
                              className="buttons background-button"
                              // onClick={() => rejectacceptrental(item?.id, 3)}
                              onClick={() => rentalContract(item?.id)}
                            >
                              {" "}
                              Accept
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </>
          ) : (
            <PostNotFound title={"No Post Found"} height={200} />
          )}
        </>

        <div
          className={`teamviewdetail w-100 ${viewmodel == true ? "show" : ""}`}
          isOpen={viewmodel}
        >
          <OTSViewModel
            type={type}
            accept={accept}
            reject={reject}
            data={data}
            setviewModel={setviewModel}
          />
        </div>

        <ConfirmModal
          isOpen={confirmDeclineModal}
          toggle={() => setConfirmDeclineModal(false)}
          title="Confirm Decline"
          message="Are you sure you want to decline this request? This action cannot be undone."
          onConfirm={confirmDeclineAction}
        />
      </div>
    </>
  );
}
